import React, { useEffect, useMemo, useRef } from 'react';

// Create a singleton pattern for mermaid import
let mermaidPromise = null;
const getMermaid = () => {
  if (!mermaidPromise) {
    mermaidPromise = import('mermaid').then((module) => {
      const mermaid = module.default;
      mermaid.initialize({
        startOnLoad: true,
        securityLevel: 'loose',
      });
      return mermaid;
    });
  }
  return mermaidPromise;
};

const formatSource = (src) => {
  if (!src) return '';
  let formatted = src.replace(/\\n/g, '\n');
  formatted = formatted.replace(/-->\s+\|/g, '-->|');
  formatted = formatted.replace(/\|\s+/g, '|');
  return formatted;
};

const MermaidPreview = React.memo(({ source, id }) => {
  const mermaidRef = useRef(null);

  useEffect(() => {
    if (!source || !mermaidRef.current) return;

    const renderDiagram = async () => {
      try {
        const mermaid = await getMermaid();
        const formattedSource = formatSource(source);
        const element = document.getElementById(`mermaid-${id}-svg`);

        if (element) {
          element.removeAttribute('data-processed');
          mermaidRef.current.textContent = formattedSource;
        }

        await mermaid.contentLoaded();
      } catch (error) {
        console.error('Mermaid syntax error:', error.message);
        if (mermaidRef.current) {
          mermaidRef.current.innerContent = `graph TD\nA[Error: Invalid syntax]`;
        }
      }
    };

    renderDiagram();
  }, [source, id]);

  const containerStyle = useMemo(() => ({ minHeight: '100px' }), []);

  return (
    <div id={`mermaid-${id}-svg`} className="mermaid" ref={mermaidRef} style={containerStyle}>
      {formatSource(source)}
    </div>
  );
});

export default MermaidPreview;
